module.exports = __webpack_public_path__ + "media/images/samples/1280x768/10-5f068ba11c6f8822fe3bb82139243850.jpg";